import {createSlice, PayloadAction} from '@reduxjs/toolkit'; 

type InitialState ={
    value:CartState;
}

type CartState = {
    price:string
}


const initialState = {
    value:{
        price:'1000'
    } as CartState, 
     
} as InitialState

export const cart = createSlice({
    name:'cart',
    initialState,
    reducers:{
        defaultPrice:()=>{
            return initialState
        },
        setPrice:(state,action:PayloadAction<string> )=>{
            return {
                value:{
                    price:action.payload 
                }
            }
        }
    } 
});

export const {defaultPrice, setPrice} = cart.actions
export default cart.reducer